<template>
  <b-overlay
    :show="_show"
    rounded="lg"
  >
    <b-card>
      <b-row>
        <b-col
          md="3"
          class="mb-3"
        >
          <label for="trendyol-link-input">Trendyol Linki ile Ara</label>
          <b-form-input
            id="trendyol-link-input"
            v-model="_searchForm.productContentId"
            placeholder="Trendyol linkini girin"
            @keyup.enter="setSearchFormBy('productContentId')"
            :class="{ 'is-active-search': _searchKey === 'productContentId' }"
          />
        </b-col>

        <b-col
          md="2"
          class="mb-3"
        >
          <label for="barcode-input">Barkod ile Ara</label>
          <b-form-input
            id="barcode-input"
            v-model="_searchForm.variantBarcodes"
            placeholder="Barkod girin"
            @keyup.enter="setSearchFormBy('variantBarcodes')"
            :class="{ 'is-active-search': _searchKey === 'variantBarcodes' }"
          />
        </b-col>

        <b-col
          md="2"
          class="mb-3"
        >
          <label for="barcode-input-2">Barkod ile Ara</label>
          <b-form-input
            id="barcode-input-2"
            v-model="_searchForm.barcode"
            placeholder="Barkod girin"
            @keyup.enter="setSearchFormBy('barcode')"
            :class="{ 'is-active-search': _searchKey === 'barcode' }"
          />
        </b-col>

        <b-col
          md="3"
          class="mb-3"
        >
          <label for="product-name-input">Ürün Adı ile Ara</label>
          <b-form-input
            id="product-name-input"
            v-model="_searchForm.productName"
            placeholder="Ürün adını girin"
            @keyup.enter="setSearchFormBy('productName')"
            :class="{ 'is-active-search': _searchKey === 'productName' }"
          />
        </b-col>
        <b-col
          md="2"
          class="mb-3"
        >
          <label for="product-name-input">Ty Marka ile Ara</label>
          <div class="d-flex gap-2">
            <v-select
              v-model="_searchForm.brandIds"
              :options="brands"
              label="name"
              :reduce="item => item.ty_id"
              input-id="brand"
              multiple
              placeholder="Markalar"
              :filterable="true"
              @search="getBrands"
              class="flex-grow-1"
              :class="{ 'is-active-search': _searchKey === 'brandIds' }"
            />
            <b-button @click="setSearchFormBy('brandIds')">Ara</b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import vSelect from "vue-select";

export default {
  name: 'SearchProduct',
  components: {vSelect},
  computed: {
    ...mapGetters('tySearchProduct', ['_show', '_searchForm', '_searchKey']),
    ...mapGetters('tyBrands', ['_brands']),
    brands() {
      return this._brands.slice(0, 100)
    }
  },
  mounted() {
    const barcode = this.$route.query.barcode
    const name = this.$route.query.name
    
    if (barcode) {
      this._searchForm.variantBarcodes = barcode
      this._searchForm.barcode = barcode
    }
    
    if (name) {
      this._searchForm.productName = name
    }
  },
  methods: {
    ...mapActions('tySearchProduct', ['setSearchFormBy']),
    getBrands(searchText) {
      if (!searchText || searchText.length < 3) {
        return;
      }

      if (this.brandSearchTimeout) {
        clearTimeout(this.brandSearchTimeout);
      }
      this.brandSearchTimeout = setTimeout(() => {
        this.$store.state.tyBrands.search.name = searchText;
        this.$store.dispatch('tyBrands/getAll');
      }, 1000);
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.is-active-search {
  background-color: #d4edda !important;
  border-color: #28a745 !important;
}
</style>
